import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
	position: relative;
	margin-top: 24px;
	text-align: center;
	flex: 1;
	.holla-step-container {
		width: 120px;
		margin: auto;
		.holla-step-icon-1 {
			position: relative;
			width: 35px;
			height: 35px;
			margin: auto;
			background-color: #393939;
			color: #ffffffa6;
			border-radius: 25px;
			cursor: pointer;
			line-height: 35px;
			font-size: 20px;
			font-weight: bold;
			opacity: 1;
		}
		.holla-step-icon {
			position: relative;
			width: 44px;
			height: 44px;
			margin: auto;
			background-color: #393939;
			color: #ffffffa6;
			border-radius: 25px;
			cursor: pointer;
			line-height: 45px;
			font-size: 25px;
    		font-weight: bold;
			opacity: 1;
		}
		.holla-step-tail {
			position: absolute;
		    left: 63%;
			top: 13px;
			width: Calc(100% - 26%);
			height: 3px;
			margin-top: 7px;
			background-color: #000;
			opacity: 1;
		}
		.holla-step-content {
			margin-top: 12px;
			line-height: 1.2;
			color: #808083;
			opacity: 1;
			font-size: 17px;
		}
	}
	.progress {
		.holla-step-status {
			width: 60px;
			height: 60px;
			border-radius: 30px;
			border: 5px solid #000;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
		.holla-step-content {
			font-weight: bold;
			color: #FFFFFF;
			letter-spacing: 1px;
			opacity: 1;
			font-size: 18;
			margin-top: 20px;
		}
		.holla-step-icon , .holla-step-icon-1{
			color: #fff;
			border: 3px solid #FFFFFF;
			line-height: 42px;
			font-size: 30px;
			opacity: 1;
			width: 50px;
			height: 50px;
		}

		.holla-step-tail {
			top: 15px;
	}
	}
	.finish {
		.holla-step-icon, .holla-step-tail, .holla-step-content ,.holla-step-icon-1{
			opacity: 0.7;
		}
		.holla-step-status {
			width: 18px;
			height: 8px;
			border-left: 2px solid #2DB300;
			border-bottom: 2px solid #2DB300;
			position: absolute;
			left: 52%;
			top: -18px;
			transform: translate(-50%, 0) rotateZ(-45deg);
		}
	}
	.step1 {
		.holla-step-icon,
		.holla-step-tail ,
		.holla-step-icon-1{
			background-image: linear-gradient(to right, #F0A93F, #F18D40);
		}
		&.progress {
			.holla-step-status {
				border-color: #F18D40;
			}
		}
	}
	.step2 {
		.holla-step-icon,
		.holla-step-tail ,
		.holla-step-icon-1{
			background-image: linear-gradient(to right, #F28041, #F56B5E);
		}
		&.progress {
			.holla-step-status {
				border-color: #F56B5E;
			}
		}
	}
	.step3 {
		.holla-step-icon,
		.holla-step-tail ,
		.holla-step-icon-1{
			background-image: linear-gradient(to right, #F6636A, #E35091);
		}
		&.progress {
			.holla-step-status {
				border-color: #E35091;
			}
		}
	}
	.step4 {
		.holla-step-icon,
		.holla-step-tail,
		.holla-step-icon-1 {
			background-image: linear-gradient(to right, #D54AA2, #B03ACF);
		}
		&.progress {
			.holla-step-status {
				border-color: #B03ACF;
			}
		}
	}
	.step5 {
		.holla-step-icon,
		.holla-step-tail,
		.holla-step-icon-1 {
			background-image: linear-gradient(to right, #A336DF, #8E55EA);
		}
		&.progress {
			.holla-step-status {
				border-color: #8E55EA;
			}
		}
	}
	.step6 {
		.holla-step-icon,
		.holla-step-tail,
		.holla-step-icon-1 {
			background-image: linear-gradient(to right, #8760EF, #7487F3);
		}
		&.progress {
			.holla-step-status {
				border-color: #7487F3;
			}
		}
	}
	&:last-child {
		.holla-step-tail {
			display: none;
		}
	}
	@media (max-width: 1200px) {
		.holla-step-container {
			width: 50px;
			margin: auto;
			.holla-step-icon,.holla-step-icon-1 {
				position: relative;
				width: 32px;
    			height: 32px;
				margin: auto;
				background-color: #393939;
				color: #fff;
				border-radius: 16px;
				cursor: pointer;
				line-height: 33px;
				font-size: 14px;
			}
			.holla-step-tail {
				position: absolute;
			    left: 62%;
				top: 10px;
				width: Calc(100% - 24%);
				height: 3px;
				background-color: #000;
			}
			.holla-step-content {
				margin-top: 12px;
				line-height: 1.2;
			}
		}
		.step1, .step2, .step3, .step4, .step5 {
			&.progress {
				.holla-step-status {
					width: 45px;
					height: 45px;
				}
				.holla-step-icon,.holla-step-icon-1 {
				width: 36px;
    			height: 36px;
				border-radius: 20px;
				line-height: 33px;
			}
			}
		}
	}
	@media (max-width: 768px) {
		.holla-step-container {
			.holla-step-tail {
				left: 65%;
				top: 9px;
				width: Calc(100% - 30%);
			}
			.holla-step-content {
				font-size: 13px !important;
			}
		}
	}
`;

export default class Step extends Component {
	render() {
		const { step, content, onClick, status, setup_Success } = this.props;
		let className = 'holla-step-container step' + step;
		if (status === 1) {
			className += ' progress';
		} else if (status === 2) {
			className += ' finish';
		}
		return (
			<Wrapper className="holla-step-item">
				<div className={className} style={{width:(status === 1 && step === 5 )? '135px':''}}>
					<div className={!setup_Success ?"holla-step-icon" :"holla-step-icon-1"} onClick={onClick}>
						<div className="holla-step-status"></div>
						{step}
					</div>
					<div className="holla-step-tail"></div>
					<div className="holla-step-content" style={{ fontSize: setup_Success ? '14px' :'' }}>{content}</div>
				</div>
			</Wrapper>
		);
	}
}
